import { render, staticRenderFns } from "./PhotoGroup.vue?vue&type=template&id=18efa0be"
import script from "./PhotoGroup.vue?vue&type=script&lang=ts"
export * from "./PhotoGroup.vue?vue&type=script&lang=ts"
import style0 from "./PhotoGroup.vue?vue&type=style&index=0&id=18efa0be&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppIcon: require('/builds/project/wyffest/frontend/components/app/AppIcon.vue').default})
